/**
 * Step background class for sync progress. One function per file.
 */
export function getStepBg(status: string): string {
  switch (status) {
    case "completed":
      return "bg-emerald-500";
    case "in_progress":
      return "bg-indigo-500";
    case "failed":
      return "bg-rose-500";
    default:
      return "bg-slate-200 dark:bg-slate-700";
  }
}
